export enum ModalStates {
    OPEN,
    CLOSED
}
